module.exports = __webpack_public_path__ + "fb3a38abeae902dbeb0896ef8f69fd8b.pdf";